module.exports = __webpack_public_path__ + "static/media/big-deal-50DM-background.6db8e22d.jpg";